"use client";

import { ReactNode } from "react";
import { motion } from "framer-motion";

const platforms = [
  { name: "Instagram", icon: "instagram" },
  { name: "Facebook", icon: "facebook" },
  { name: "LinkedIn", icon: "linkedin" },
  { name: "TikTok", icon: "tiktok" },
  { name: "Pinterest", icon: "pinterest" },
  { name: "YouTube", icon: "youtube" },
  { name: "X", icon: "twitter" },
];

const PlatformIcon = ({ platform }: { platform: string }) => {
  const icons: Record<string, ReactNode> = {
    instagram: (
      <svg viewBox="0 0 24 24" className="w-6 h-6" fill="currentColor">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
      </svg>
    ),
    facebook: (
      <svg viewBox="0 0 24 24" className="w-6 h-6" fill="currentColor">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
      </svg>
    ),
    linkedin: (
      <svg viewBox="0 0 24 24" className="w-6 h-6" fill="currentColor">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
      </svg>
    ),
    tiktok: (
      <svg viewBox="0 0 24 24" className="w-6 h-6" fill="currentColor">
        <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
      </svg>
    ),
    pinterest: (
      <svg viewBox="0 0 24 24" className="w-6 h-6" fill="currentColor">
        <path d="M12 0C5.373 0 0 5.372 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738.098.119.112.224.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12z"/>
      </svg>
    ),
    youtube: (
      <svg viewBox="0 0 24 24" className="w-6 h-6" fill="currentColor">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
      </svg>
    ),
    twitter: (
      <svg viewBox="0 0 24 24" className="w-5 h-5" fill="currentColor">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
      </svg>
    ),
  };

  return icons[platform] || null;
};

export function PlatformIconsGrid() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.05 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.3 }
    },
  };

  // Split platforms for checkerboard: row1 gets indices 0,1,2 | row2 gets indices 3,4,5,6
  const row1Platforms = platforms.slice(0, 3); // Instagram, Facebook, LinkedIn
  const row2Platforms = platforms.slice(3);    // TikTok, Pinterest, YouTube, X

  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-50px" }}
      className="flex flex-col items-start md:flex-col md:items-center md:justify-center gap-3 xl:flex-row xl:gap-x-8"
    >
      {/* Text label - desktop only, proportional on portrait tablets */}
      <motion.div
        variants={itemVariants}
        className="hidden md:flex shrink-0"
      >
        <span className="text-xs lg:text-base xl:text-lg landscape:lg:text-base landscape:xl:text-lg portrait:text-[clamp(1.25rem,2.2vw,1.65rem)] text-foreground/70 font-medium whitespace-nowrap">
          Automate posting for
        </span>
      </motion.div>

      {/* Mobile: Vertical 2-column layout | Desktop: Single row */}
      <div className="md:hidden flex items-start gap-2 max-[375px]:gap-1.5 min-[425px]:gap-3 min-[480px]:gap-3 sm:gap-3.5">
        {/* Column 1: Vertical text */}
        <span
          className="text-[10px] max-[375px]:text-[10px] min-[375px]:max-[480px]:text-[11px] min-[480px]:max-[640px]:text-[11.5px] min-[640px]:max-[768px]:text-[12px] min-[768px]:text-sm sm:text-sm text-foreground/70 font-medium"
          style={{ writingMode: 'vertical-rl', transform: 'rotate(180deg)' }}
        >
          Automate posting for
        </span>

        {/* Column 2: Vertical logos */}
        <div className="flex flex-col gap-1.5 max-[375px]:gap-1 min-[375px]:max-[480px]:gap-2 min-[480px]:max-[640px]:gap-2 min-[640px]:max-[768px]:gap-2.5 min-[768px]:gap-2.5 sm:gap-3">
          {platforms.map((platform) => (
            <motion.div
              key={platform.name}
              variants={itemVariants}
              className="flex items-center justify-center text-foreground/80 hover:text-foreground transition-colors"
            >
              <div className="w-5 h-5 max-[375px]:w-[22px] max-[375px]:h-[22px] min-[375px]:max-[480px]:w-[26px] min-[375px]:max-[480px]:h-[26px] min-[480px]:max-[640px]:w-[28px] min-[480px]:max-[640px]:h-[28px] min-[640px]:max-[768px]:w-[30px] min-[640px]:max-[768px]:h-[30px] min-[768px]:w-7 min-[768px]:h-7 sm:w-[30px] sm:h-[30px] flex items-center justify-center [&>svg]:w-full [&>svg]:h-full">
                <PlatformIcon platform={platform.icon} />
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Desktop: Flexible row with names - proportional on portrait tablets */}
      <div className="hidden md:flex md:flex-wrap md:justify-center md:gap-x-5 md:gap-y-2 lg:gap-x-6 xl:gap-x-8 xl:flex-nowrap landscape:gap-x-5 landscape:gap-y-2 portrait:gap-x-[clamp(2rem,3.5vw,3rem)] portrait:gap-y-[clamp(1rem,1.8vh,1.5rem)]">
        {platforms.map((platform) => (
          <motion.div
            key={platform.name}
            variants={itemVariants}
            className="flex items-center gap-1.5 lg:gap-2 xl:gap-2 landscape:gap-1.5 portrait:gap-[clamp(0.75rem,1.2vw,1rem)] text-foreground/80 hover:text-foreground transition-colors shrink-0"
          >
            <div className="w-5 h-5 lg:w-6 lg:h-6 xl:w-7 xl:h-7 landscape:lg:w-6 landscape:lg:h-6 landscape:xl:w-7 landscape:xl:h-7 portrait:w-[clamp(1.75rem,3vw,2.5rem)] portrait:h-[clamp(1.75rem,3vw,2.5rem)] flex items-center justify-center [&>svg]:w-full [&>svg]:h-full">
              <PlatformIcon platform={platform.icon} />
            </div>
            <span className="text-xs lg:text-base xl:text-lg landscape:lg:text-base landscape:xl:text-lg portrait:text-[clamp(1.25rem,2.2vw,1.65rem)] font-medium whitespace-nowrap">
              {platform.name}
            </span>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
}
